// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent{
  title = 'SIMATIC PCS neo portal';

  constructor(private readonly translate: TranslateService,
  ) {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

}